// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2ytVZ","footer":"ModalFilter_footer__1VZkw"};